import React, { Component } from 'react';

export default class Page404 extends Component {
	render() {
		return (
			<div>404 not found</div>
		);
	}
}
